import { useContext, useEffect, useMemo } from 'react';

import { AiSmartFilterContext } from '../../AiSmartFilter/__context/AiSmartFilterProvider';
import {
    FilterGroupData,
    RequestFilterData,
    RequestFilterGroupData,
} from '../../AiSmartFilter/types';
import { FilterElement } from '../types';

const defaultGroupData: RequestFilterGroupData = {
    label: '',
    multi: false,
    minLogic: false,
    refKey: '',
};

const isFilterData = (
    data: RequestFilterData | undefined
): data is RequestFilterData => !!data;

export const useAiSmartFilterConfig = (
    filterList: FilterElement[],
    groupData: RequestFilterGroupData = defaultGroupData,
    isVisible = false
) => {
    const ref = useContext(AiSmartFilterContext);
    const filterGroupData: FilterGroupData = useMemo(() => {
        if (!groupData.refKey) {
            return {
                ...defaultGroupData,
                isVisible: false,
                filters: [],
            };
        }
        const filters = filterList
            .map((filter) => filter.kiFilterData)
            .filter(isFilterData);

        return {
            label: groupData.label,
            multi: groupData.multi,
            minLogic: groupData.minLogic,
            isVisible: isVisible,
            filters,
        };
    }, [
        filterList,
        groupData.label,
        groupData.multi,
        groupData.minLogic,
        isVisible,
        groupData.refKey,
    ]);

    useEffect(() => {
        if (groupData.refKey) {
            ref.current = {
                ...ref.current,
                [groupData.refKey]: filterGroupData,
            };
        }

        return () => {
            if (groupData.refKey) {
                ref.current = Object.fromEntries(
                    Object.entries(ref.current).filter(
                        ([key]) => key !== groupData.refKey
                    )
                );
            }
        };
    }, [filterGroupData, groupData.refKey, ref]);
};
